import $ from 'jquery';

const generator = $('.id-generator-app');
const $window = $(window);

$(function() {
    generator.on('DOMSubtreeModified', function() {
        const elements = $(".tooltip");
        elements.each( function () {
            const element = $(this);
            let rect = element[0].getBoundingClientRect();
            if ($window.width() < rect.right){
                element.addClass("right");
            }
        });
    });
});